import { render, staticRenderFns } from "./AbsenceApproverTable.vue?vue&type=template&id=0fc60752&scoped=true&"
import script from "./AbsenceApproverTable.vue?vue&type=script&lang=js&"
export * from "./AbsenceApproverTable.vue?vue&type=script&lang=js&"
import style0 from "./AbsenceApproverTable.vue?vue&type=style&index=0&id=0fc60752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc60752",
  null
  
)

component.options.__file = "AbsenceApproverTable.vue"
export default component.exports